import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { IonicModule, ModalController  } from '@ionic/angular';
import { ModalConfirmationProps, NotificationConfig, NotificationTypeEnum } from 'src/app/models/config-view-models';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
})
export class ConfirmationModalComponent  implements OnInit {
  @Input() modalProps!: ModalConfirmationProps;  
  NotificationConfig = NotificationConfig;
  NotificationEnum = NotificationTypeEnum;
  constructor(private modalController: ModalController) { }
  

  ngOnInit() {

  }
  accept() {
    if (this.modalProps.onAccept) {
      this.modalProps.onAccept();  // Call the accept callback
    }
    this.dismiss();
  }

  // Trigger reject callback and close modal
  reject() {
    if (this.modalProps.onReject) {
      this.modalProps.onReject();  // Call the reject callback
    }
    this.dismiss();
  }

  // Dismiss the modal
  dismiss() {
    this.modalController.dismiss();
  }


}
